import { render } from "./ExternalUnitsTab.vue?vue&type=template&id=ede46036"
import script from "./ExternalUnitsTab.vue?vue&type=script&lang=js"
export * from "./ExternalUnitsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__